module.exports = __webpack_public_path__ + "img/deal-three.9735d5cc.jpg";